import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ListFormHoc from "../../../utils/listFormHoc";
import List from "./patientList";
import Form from "./form/index";
import { setMainHeading } from "../../../redux/modules/mainHeading/slice";
import { useLocation } from "react-router-dom";

export default function PatientManagement() {
    const dispatch = useDispatch();
    const location = useLocation();
    const editPatientId = location.state?.editPatientId;
    const initialItemData = editPatientId ? { _id: editPatientId, pId: editPatientId } : null;

    useEffect(()=>{
        dispatch(setMainHeading("Patient Management"))
    },[dispatch])

    return (
        <>
            <ListFormHoc
                List={List}
                Form={Form}
                initialShowList={!editPatientId}
                initialItemData={initialItemData}
                writeModule="patients"
            />
        </>
    );
}
